import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {
  LANDING_ROUTE,
  WSPAY_PAYMENT_ERROR,
  WSPAY_PAYMENT_SUCCESS
} from "src/app/app-routing.module";
import {WsPayService} from "@services";
import {
  WspayConfirmation, PaymentStatus,
  WspayResult
} from "@model";
import {DOCUMENT} from "@angular/common";

export const WsPayStatusResolver: ResolveFn<Observable<WspayConfirmation | null> |
  Promise<WspayConfirmation> | WspayConfirmation> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   router: Router = inject(Router),
   document: Document = inject(DOCUMENT),
   wsPayService: WsPayService = inject(WsPayService))
    : Observable<WspayConfirmation | null> |
    Promise<WspayConfirmation> | WspayConfirmation => {
    let signature: string = route.queryParams['Signature'];
    let shoppingCartID: string = route.queryParams['ShoppingCartID'];
    let approvalCode: string = (route.queryParams['ApprovalCode'] && route.queryParams['ApprovalCode'] !== "") ? route.queryParams['ApprovalCode'] : null;
    let errorMessage: string = (route.queryParams['ErrorMessage'] && route.queryParams['ErrorMessage'] !== "") ? route.queryParams['ErrorMessage'] : null;
    if (!signature || !shoppingCartID || !approvalCode) {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    } else {
      return wsPayService.fetchWsPayResult(new WspayResult(shoppingCartID, signature, checkWsPayStatus(document.location.href), approvalCode, errorMessage))
        .pipe(take(1),
          mergeMap((res: WspayConfirmation | null) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    }
  }

function checkWsPayStatus(path:string|undefined): PaymentStatus {
  if (path && path.includes(WSPAY_PAYMENT_SUCCESS)) {
    return PaymentStatus.SUCCESS;
  } else if (path && path.includes(WSPAY_PAYMENT_ERROR)) {
    return PaymentStatus.ERROR;
  } else {
    return PaymentStatus.CANCEL;
  }
}
